const api_url = "https://api.planmychutti.in/api/v1";
export default api_url;
